(ns minorodata.transformations.subs
  (:require
   [cljs.reader :as c.reader]
   [clojure.string :as c.string]
   [minorodata.app.utils :refer [format-transform-status]]
   [minorodata.utils :refer [find-by-field]]
   [re-frame.core :as re-frame]))


(defn select-transform-item [{:transform/keys [id master-id group-id name description tags updated-at updated-by]}]
  {:id          id
   :master-id   master-id
   :group-id    group-id
   :name        name
   :description description
   :updated-at  updated-at
   :updated-by  (:searchable-user/username updated-by)
   :tags        tags
   :type        :transform})


(defn select-group-item [{:group/keys [id name description updated-at updated-by]}]
  {:id          id
   :name        name
   :description description
   :updated-at  updated-at
   :updated-by  (:searchable-user/username updated-by)
   :type        :group})


(re-frame/reg-sub
 :transformations.subs/search-results
 (fn []
   (re-frame/subscribe
    [:transformations-search/pull
     '[* {:transformations-search/transforms [* {:transform/updated-by [:searchable-user/username]}]
          :transformations-search/groups     [* {:group/updated-by [:searchable-user/username]}]}]]))
 (fn [search]
   (let [{:transformations-search/keys [groups transforms type]} search]
     {:matched (case type
                 :transforms (map select-transform-item transforms)
                 :groups (map select-group-item groups)
                 (concat (map select-transform-item transforms)
                         (map select-group-item groups)))})))


(defn finished-job? [{:job/keys [status]}]
  (or (= status :failed)
      (= status :success)))


(defn format-error [errors]
  (let [original-error (-> errors :task/errors first :task/errors first :task/error)]
    (some-> original-error
            (c.string/replace #"#error " "")
            c.reader/read-string
            :cause)))


(defn format-job [{:job/keys [id name status start-time end-time errors]}]
  {:id       id
   :name     name
   :status   status
   :error    (format-error errors)
   :started  start-time
   :finished end-time})


(re-frame/reg-sub
 :transformations.subs/finished-jobs
 (fn []
   (re-frame/subscribe [:transformations-view/pull '[{:transformations-view/jobs [*]}]]))
 (fn [view]
   (->> (:transformations-view/jobs view)
        (filter finished-job?)
        (map format-job))))

(re-frame/reg-sub
 :transformations.subs/last-status
 (fn []
   [(re-frame/subscribe [:transform-status-list/prop :transform-status-list/statuses])
    (re-frame/subscribe [:app.subs/timezone])])
 (fn [[statuses timezone] [_ transform-id]]
   (format-transform-status
    timezone
    (find-by-field statuses :transform-id transform-id))))
